import type { Actor } from '@/entities'

export const getActorContactId = (actor: Actor | null | undefined) =>
    actor?.type === 'contact' ? actor.contact : null
